<template>
  <div class="headerNav">
    <div class="headerFirst">
      <div class="iconStyle">
        <i class="el-icon-s-fold" v-if="!$collapse" @click="changeTab" />
        <i class="el-icon-s-unfold" v-else @click="changeTab" />
      </div>

      <!-- <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="(item, index) in $breadList" :title="item" :key="index">{{
          item
        }}</el-breadcrumb-item>
      </el-breadcrumb> -->
      <TopLevelMenu />
    </div>
    <div class="flexLayout">
      <i
        class="elOpStyle iconColor el-icon-notebook-2"
        style="font-size: 23px"
        title="数据目录"
        @click="goMenu"
      ></i>
      <el-select
        style="margin-right: 20px"
        v-model="value"
        clearable
        filterable
        remote
        placeholder="请输入关键词"
        :remote-method="remoteMethod"
        :loading="loading"
        value-key="tableId"
      >
        <el-option-group
          v-for="group in options"
          :key="group.id + 'group'"
          :label="group.menuName"
        >
          <el-option
            v-for="item in group.permissionList"
            :key="item.tableId"
            :label="item.menuName"
            :value="item"
          >
          </el-option>
        </el-option-group>
      </el-select>
      <el-dropdown @command="commandFun">
        <span class="el-dropdown-link">
          <el-badge is-dot v-if="$todoCount + $messageCount > 0">
            <div class="userStyle"></div>
          </el-badge>
          <div class="userStyle" v-else></div>
          <span>{{
            $userInfo.nickName ? $userInfo.nickName : "默认用户"
          }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="messageCenter"
            >消息中心
            <el-badge
              v-if="$messageCount > 0"
              :value="$messageCount"
            ></el-badge>
          </el-dropdown-item>
          <el-dropdown-item command="flowTask" v-if="socket"
            >流程任务
            <el-badge v-if="$todoCount > 0" :value="$todoCount"></el-badge
          ></el-dropdown-item>
          <el-dropdown-item command="helpCenter">帮助中心</el-dropdown-item>
          <el-dropdown-item command="changeColor">配色方案</el-dropdown-item>
          <el-dropdown-item command="changePass">修改密码</el-dropdown-item>
          <el-dropdown-item command="version">更新日志</el-dropdown-item>
          <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { updatePassWord } from "@/api/userList";
import { reSetTreeData2 } from "@/utils/index.js";
import TopLevelMenu from "./TopLevelMenu";

export default {
  name: "HeaderNav",
  components: { TopLevelMenu },
  data() {
    return {
      taskNum: 0,
      title: process.env.VUE_APP_TITLE,
      socket: process.env.VUE_APP_SOCKET,
      sourceOptions: [],
      options: [],
      value: "",
      loading: false,
    };
  },
  watch: {
    // value: {
    //   immediate: true,
    //   deep: true,
    //   handler(val) {
    //     if (val) {
    //       this.goPage(val);
    //       this.focusFun();
    //     } else {
    //       this.focusFun();
    //     }
    //   },
    // },
  },
  methods: {
    changeTab() {
      this.$store.commit("utils/SET_COLLAPSE", !this.$collapse);
    },
    // 全局搜索
    remoteMethod(query) {
      if (query) {
        this.options = this.filterFun(query);
      } else {
        this.options = [];
      }
    },
    commandFun(value) {
      const self = this;
      if (value == "loginOut") {
        this.$confirm("是否确认退出登录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            self.$store.dispatch("utils/init");
            localStorage.clear();
            sessionStorage.clear();
            self.$router.push("/login");
          })
          .catch(() => {
            return;
          });
      } else if (value == "changePass") {
        self
          .$prompt(
            "请输入新密码（密码必须由大写字母，小写字母，数字，特殊字符组成(满足3种组合即可)，且长度大于8位）",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              inputPattern:
                /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,1000}$/,
              inputErrorMessage: "密码格式不满足",
            }
          )
          .then(({ value }) => {
            if (value) {
              let params = {
                id: self.$userInfo.id,
                password: this.$md5(value),
              };
              updatePassWord(params).then((res) => {
                if (res) {
                  self.$message.success("修改成功");
                }
              });
            } else {
              self.$message.warning("请输入密码");
            }
          })
          .catch(() => {
            return;
          });
      } else if (value == "flowTask") {
        this.$router.push({
          path: "/taskCenter",
          query: { id: new Date().getTime() },
        });
      } else if (value == "changeColor") {
        this.$router.push({
          path: "/colorList",
          query: {
            id: new Date().getTime(),
          },
        });
      } else if (value == "helpCenter") {
        window.open("http://worksheet.koalacloud.com:8000/guide/intro.html");
      } else if (value == "messageCenter") {
        this.$router.push({
          path: "/messageCenter",
          query: { id: new Date().getTime() },
        });
      } else if (value == "version") {
        this.$router.push({
          path: "/version",
          query: { id: new Date().getTime() },
        });
      }
    },
    // 数据目录跳转
    goMenu() {
      this.$router.push({
        path: "/dataLink",
        query: { id: new Date().getTime() },
      });
    },
    // 搜索条件
    filterFun(name) {
      let arr = [];
      this.sourceOptions.map((res) => {
        let paramID = "";
        let newResOb = this.$deepClone(res);
        // 菜单直接搜索到
        if (res.menuName.indexOf(name) !== -1) {
          paramID = res.id;
        }
        let newArr = [];
        // 表单搜索
        res.permissionList.map((newRes) => {
          // 表单搜索到
          if (newRes.menuName.indexOf(name) !== -1) {
            newArr.push(newRes);
            paramID = res.id;
          }
        });
        // 表单搜索有结果，重写菜单下表单列表
        if (newArr.length > 0) {
          newResOb.permissionList = newArr;
        }
        // 搜索到重写所有菜单
        if (paramID) {
          arr.push(newResOb);
        }
      });
      return arr;
    },
    // 获取焦点方法
    focusFun() {
      this.value = "";
      this.sourceOptions = reSetTreeData2(this.$routerList);
      this.options = this.sourceOptions;
    },
    // 大搜跳转页面
    goPage(item) {
      // 判断是否是外部链接
      let reg = new RegExp(/(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g);
      if (reg.test(item.menuUrl)) {
        this.$router.push({
          path: "/outerPath",
          query: { id: item.tableId, url: item.menuUrl },
        });
      } else {
        this.$router.push({ path: item.menuUrl, query: { id: item.tableId } });
      }
    },
  },
};
</script>

<style lang="stylus">
.headerNav
  padding: 0 20px
  width: 100%
  display: flex
  align-items: center
  justify-content: space-between
  .userStyle
    position: relative
    width: 26px
    height: 26px
    background: url('~@/assets/images/user.png')
    background-size: cover
  .headerFirst
    display: flex
    align-items: center
    .iconStyle
      color: $headIconColor
      font-size: 26px
      cursor: pointer
      margin-right: 20px
  .iconColor
    color: $headIconColor !important
  .el-breadcrumb__item
    color: $headValueColor !important
    font-size: 16px
    max-width: 240px
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis
  .el-breadcrumb__inner
    color: $headValueColor !important
  .el-dropdown-link
    color: $headValueColor !important
    display: flex
    align-items: center
    span
      font-weight: 500
      font-size: 15px
      margin-left: 10px
</style>
